import { parseInfinityAutoScrollSec, type InfinityAutoScrollSec } from "@gooner/shared";

/**
 * The Infinite Scroll's auto-scroll wait, remembered per BROWSER (2026-09-14). A viewer's
 * taste, not a screen's fact — so not `screenSettings.ts`, which is keyed by device id and
 * only exists once a screen is claimable, while the scroll is reached with no device at
 * all (`/screen?view=infinity:random`). One of the `gp:` family; blocked storage reads as
 * off and a full one drops the write, the guide flag's manners.
 */
const KEY = "gp:infinity-auto-scroll";

export function readInfinityAutoScroll(): InfinityAutoScrollSec {
  try {
    const raw = localStorage.getItem(KEY);
    return parseInfinityAutoScrollSec(raw === null ? 0 : Number(raw));
  } catch {
    return 0;
  }
}

export function writeInfinityAutoScroll(sec: InfinityAutoScrollSec): void {
  try {
    if (sec === 0) localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, String(sec));
  } catch {
    /* quota or blocked: the choice lives for the page and no longer */
  }
}
